import { RootPaths } from "@src/appV2/App/paths";

import { WORKPLACE_REFERRAL_SCREEN_NAME, WORKPLACE_REFERRAL_STATS_SCREEN_NAME } from "./constants";

export const WORKPLACE_REFERRALS_PATH = "workplace-referrals";
export const WORKPLACE_REFERRALS_STATS_PATH = `${WORKPLACE_REFERRALS_PATH}/stats`;
export const WORKPLACE_REFERRALS_WITH_ACCOUNTS_PATH = `${RootPaths.APP_V2_HOME}/accounts/${WORKPLACE_REFERRALS_PATH}`;
export const WORKPLACE_REFERRALS_STATS_WITH_ACCOUNTS_PATH = `${RootPaths.APP_V2_HOME}/accounts/${WORKPLACE_REFERRALS_STATS_PATH}`;

export const EARNINGS_INFO_PATH = "earnings-info";
export const INVITE_WORKPLACE_PATH = "invite-workplace";

export const WORKPLACE_REFERRALS_EARNINGS_INFO_MODAL_FULL_PATH = `${WORKPLACE_REFERRALS_WITH_ACCOUNTS_PATH}/${EARNINGS_INFO_PATH}`;
export const WORKPLACE_REFERRALS_INVITE_WORKPLACE_MODAL_FULL_PATH = `${WORKPLACE_REFERRALS_WITH_ACCOUNTS_PATH}/${INVITE_WORKPLACE_PATH}`;

export const WorkplaceReferralRouterPath = {
  WORKPLACE_REFERRAL_PATH: WORKPLACE_REFERRALS_WITH_ACCOUNTS_PATH,
  WORKPLACE_REFERRALS_STATS_PATH: WORKPLACE_REFERRALS_STATS_WITH_ACCOUNTS_PATH,
};

export const WorkplaceReferralRouterPathInfo = {
  WORKPLACE_REFERRAL_PATH: {
    name: WORKPLACE_REFERRAL_SCREEN_NAME,
  },
  WORKPLACE_REFERRALS_STATS_PATH: {
    name: WORKPLACE_REFERRAL_STATS_SCREEN_NAME,
  },
};
